module.exports = __webpack_public_path__ + "img/date_ok.f9abbf92.jpg";